import { Dialog, DialogActions } from '@mui/material';
import { getIntegrationStatusByInternalName } from 'lib/api/integrations';
import CustomButton from 'lib/designSystem/Button';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import BankAccounts from '../../../../../BusinessProfile/Profile/components/BankAccounts';
import Buro from '../../../../../BusinessProfile/Profile/components/Buro';
import Client from '../../../../../BusinessProfile/Profile/components/Client';
import Contacts from '../../../../../BusinessProfile/Profile/components/Contacts';
import SuperDebt from '../../../../../BusinessProfile/Profile/components/Debt';
import StakeholderProfile from '../../../../../BusinessProfile/Profile/components/StakeholderProfile';

const NetworkBusinessDetails = (props: any) => {
  const { business, open, setOpen } = props;
  const dispatch = useDispatch();
  const startValue = 0;
  const [hasSuperDebt, setHasSuperDebt] = useState<boolean>(false);
  const [hasBuro, setHasBuro] = useState<boolean>(false);
  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: (
        <Client businessId={business.id} businessName={business.name} />
      ),
    },
    {
      index: 1,
      label: 'Contactos',
      component: <Contacts businessId={business.id} />,
    },
    {
      index: 2,
      label: 'Banco',
      component: <BankAccounts businessId={business.id} />,
    },
    {
      index: 3,
      label: 'Deuda',
      disabled: !hasSuperDebt,
      component: <SuperDebt businessId={business.id} />,
      hoverText: !hasSuperDebt
        ? 'No tienes activa la integración de deuda'
        : '',
    },
    {
      index: 4,
      label: 'Buró',
      disabled: !hasBuro,
      component: <Buro businessId={business.id} />,
      hoverText: !hasBuro ? 'No tienes activa la intración' : '',
    },
    {
      index: 5,
      label: 'Perfil Deudor',
      component: <StakeholderProfile businessId={business.id} />,
    },
  ];

  const fetchIntegrations = async () => {
    const superDebtIntegration = await getIntegrationStatusByInternalName(
      dispatch,
      'super-debt',
    );
    const buroIntegration = await getIntegrationStatusByInternalName(
      dispatch,
      'buro',
    );
    setHasSuperDebt(superDebtIntegration.status);
    setHasBuro(buroIntegration.status);
  };

  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <Dialog maxWidth="lg" fullWidth open={open} onClose={() => setOpen(false)}>
      <div style={{ padding: 20, minHeight: 200 }}>
        <EnhancedTab
          title={`${business.name}`}
          startValue={startValue}
          tabs={tabs}
        />
      </div>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          {' '}
          Salir{' '}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NetworkBusinessDetails;
